import type { ReactNode } from "react";

import { listItemCss } from "./index.styles";

interface Props {
  children: ReactNode;
  isSelected: boolean;
}
export const ListItem: React.FC<Props> = ({ children, isSelected }) => {
  return (
    <li data-is-selected={isSelected && "true"} css={listItemCss}>
      {children}
    </li>
  );
};
